export const hasElementByIndex = (index: number) => index !== -1;